import { Formik, Field, Form } from 'formik';
import React, { useEffect, useState } from 'react';
import { FormGroup, Label, Input } from 'reactstrap';
import ModalPopup from 'components/organisms/modal';
import TextArea from 'components/atoms/textarea';
import Button from 'components/atoms/button';
import { showResult } from 'infrastructure/hooks/utils';
import { useTracker } from 'infrastructure/hooks/shared/useTracker';

import type { ISendSmsDataProps } from 'infrastructure/hooks/control-panel/api';
import type { SmsModalProps } from './modal';

const SmsModalMobile: React.FC<SmsModalProps> = ({
  isOpen,
  toggle,
  patientGuid,
  smsTemplates,
  loading,
  submit,
  isRpmPanel,
  isPrimaryNumber,
}) => {
  const [topic, setTopic] = useState('');

  const { time, secondsRef, start, stop, trackerGuid, deleteTracker } =
    useTracker();

  useEffect(() => {
    start();
  }, []);

  const handleSubmit = async (values: { message: string }) => {
    stop();
    const postData: ISendSmsDataProps = {
      patientGuid,
      topic,
      type: 'sms',
      message: values.message,
      isRpmPanel,
      isPrimaryNumber,
      timerDuration: isRpmPanel ? secondsRef.current : 0,
      trackerGuid: isRpmPanel ? trackerGuid : null,
    };
    const { error } = await submit(postData);
    if (!error) {
      showResult();
      toggle();
      return;
    }
    start();
  };

  const onTemplateChange = (
    templateGuid: string,
    setFieldValue: (field: string, value: string) => void,
  ) => {
    const smsTemplate = smsTemplates.find(
      (template) => templateGuid === template.id,
    );
    setTopic(smsTemplate?.topic ?? '');
    setFieldValue('message', smsTemplate?.text ?? '');
    const messageBoxes = document.getElementsByClassName('message-mobile');
    const selectedMessageBox = document.getElementById(
      `message-mobile-${templateGuid}`,
    );
    for (let i = 0; i < messageBoxes.length; i++) {
      const messageBox = messageBoxes[i] as HTMLElement;
      if (messageBox instanceof HTMLElement) {
        messageBox.style.height = '0';
      }
    }
    if (selectedMessageBox instanceof HTMLElement) {
      selectedMessageBox.style.height = 'auto';
    }
  };

  return (
    <ModalPopup
      isOpen={isOpen}
      toggle={() => {
        toggle();
        deleteTracker();
      }}
      title="Send SMS Primary Contact"
      className="popup sms-popup"
    >
      <Formik
        initialValues={{
          message: '',
        }}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue }) => (
          <Form>
            <div>SMS Timer: {time}</div>
            <div className="sms-popup-content">
              <FormGroup tag="fieldset">
                {smsTemplates.map((template) => (
                  <FormGroup check key={template.id}>
                    <Label check>
                      <Input
                        type="radio"
                        name="template_id"
                        value={template.id}
                        onChange={() =>
                          onTemplateChange(template.id, setFieldValue)
                        }
                      />{' '}
                      {template.topic}
                    </Label>
                    <div
                      className="message-mobile"
                      id={`message-mobile-${template.id}`}
                    >
                      <Field
                        className="sms-textarea"
                        id="message"
                        name="message"
                        type="message"
                        as={TextArea}
                        rows="8"
                        placeholder="Type or select option on the left"
                      />
                      <div className="text-center">
                        <Button
                          type="submit"
                          text="Send"
                          data-cy="send-button"
                          disabled={loading}
                        />
                      </div>
                    </div>
                  </FormGroup>
                ))}
              </FormGroup>
            </div>
          </Form>
        )}
      </Formik>
    </ModalPopup>
  );
};

export default SmsModalMobile;
